/**
 * The Internet Explorer 11 implementation of Date.parse() does not support the +0000 time zone
 * format used by Prismic, but it does support the 'Z' suffix. This function detects that particular
 * situation and works around it to return a valid Date even on IE11.
 */
export default function (string) {
  const result = new Date(string);
  if (Number.isNaN(result.getTime())) {
    const fixedResult = new Date(string.replace(/\+0000$/, 'Z'));
    if (!Number.isNaN(fixedResult.getTime())) {
      return fixedResult;
    }
  }
  return result;
}
